/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

// Staff (#740): Mas Camp cash for a Box's held tickets (in full).
export const PAY_TICKETS_AT_MAS_CAMP = gql`
  mutation PayTicketsAtMasCamp($data: MasCampTicketPaymentInput!) {
    payTicketsAtMasCamp(data: $data) {
      txId
      status
      syncStatus
      paymentMode
      ticketAmount
      convenienceFee
      ticketTotal
      costumeAmount
      message
      ticketOrder {
        ticketOrderId
        status
      }
    }
  }
`;
